import { sortByObjectKey } from '@utils/collections';

type FilterUser = { id: number; name: string };

export const toSortedUserOptions = (users: Array<FilterUser>) => {
  return sortByObjectKey(
    users.map((user) => ({ value: String(user.id), label: user.name })),
    'label',
  );
};
